import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateGeneralAttestationMutation as useChCreateGeneralAttestationMutationType } from "@/modules/patients/detail/general-attestation/ch/services/__generated__/useChCreateGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useChCreateGeneralAttestationMutation($input: Ch_createGeneralAttestationInput!) {
    ch_createGeneralAttestation(input: $input) {
      ch_GeneralAttestation {
        id
        ...chGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateGeneralAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateGeneralAttestationMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateGeneralAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateGeneralAttestationMutation }
